import { EventKindDto, EventListItemDto } from "../../../autogen/bff-api";
import { EventStatusTag } from "../../sourcing-events/EventStatusTag";

/**
 * Renders the kind-appropriate status tag for a combined V1/V2 event list item,
 * mapping the read-model kinds (V1/V2) onto EventStatusTag's BSE/PUBLIC_V2 inputs.
 */
export const CombinedEventStatusTag = ({
  event,
  size = "md",
}: {
  event: EventListItemDto;
  size?: "sm" | "md" | "lg";
}) => {
  if (event.kind === EventKindDto.V1) {
    return event.bseStatus ? <EventStatusTag event={{ kind: "BSE", status: event.bseStatus }} size={size} /> : null;
  }
  return event.publicStatus ? (
    <EventStatusTag event={{ kind: "PUBLIC_V2", status: event.publicStatus }} size={size} />
  ) : null;
};
